import Editor from '@tinymce/tinymce-vue'

export function useTinyMCE() {
  // TinyMCE API Key
  // 'no-api-key' works for development but shows a warning.
  const apiKey = '7yitk0l8sup6krj4mnkosrs1zc7lwjmr1lf6e7a857himtr2'

  const defaultInit = {
    height: 500,
    menubar: false, // Hidden in your image

    // Plugins required for these buttons
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
      'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'help', 'wordcount',
    ],

    // TOOLBAR CONFIGURATION
    // Row 1: Undo/Redo | Headings | Styles | Align | Line Height | Lists | Indents
    // Row 2: Select All | Formatting | Color | Media/Inserts | Fullscreen
    // 2. Toolbar: Configured as an Array to create 2 explicit rows
    toolbar: [
      // Row 1
      'undo redo | blocks styles | align lineheight | bullist numlist checklist | outdent indent',

      // Row 2
      'selectall | bold italic underline strikethrough forecolor | link image table blockquote hr | fullscreen',
    ],

    // 3. Styles Dropdown (Replicating CKEditor 5 presets)
    style_formats: [
      // Block Styles (Applied to paragraphs/divs)
      { title: 'Info Box', block: 'div', classes: 'info-box', wrapper: true },
      { title: 'Success Box', block: 'div', classes: 'success-box', wrapper: true },
      { title: 'Warning Box', block: 'div', classes: 'warning-box', wrapper: true },
      { title: 'Side Quote', block: 'blockquote', classes: 'side-quote' },

      // Inline Styles (Applied to selected text)
      { title: 'Marker', inline: 'span', classes: 'marker' },
      { title: 'Typewriter', inline: 'code', classes: 'typewriter' },
      { title: 'Small', inline: 'small' },
    ],

    // 7. Content Styling (CSS to match CKEditor 5 visuals)
    content_style: `
      body {
        font-family: Helvetica, Arial, sans-serif;
        font-size: 14px;
        line-height: 1.6;
        color: #333;
      }

      /* --- CKEditor 5 Style Mimic --- */

      /* Info Box (Blue) */
      .info-box {
        background: #e8f0fe;
        border-left: 4px solid #4285f4;
        padding: 10px 15px;
        margin: 10px 0;
        border-radius: 4px;
      }

      /* Success Box (Green) */
      .success-box {
        background: #e6f4ea;
        border-left: 4px solid #34a853;
        padding: 10px 15px;
        margin: 10px 0;
        border-radius: 4px;
      }

      /* Warning Box (Yellow/Orange) */
      .warning-box {
        background: #fef7e0;
        border-left: 4px solid #fbbc04;
        padding: 10px 15px;
        margin: 10px 0;
        border-radius: 4px;
      }

      /* Side Quote */
      .side-quote {
        font-style: italic;
        color: #555;
        border-left: 3px solid #ccc;
        padding-left: 15px;
        margin: 15px 0;
      }

      /* Marker (Yellow Highlight) */
      .marker {
        background-color: #fdfd77;
        padding: 2px 4px;
        border-radius: 2px;
      }

      /* Typewriter (Monospace) */
      .typewriter {
        font-family: 'Courier New', Courier, monospace;
        background-color: #f5f5f5;
        padding: 2px 4px;
        border-radius: 4px;
        color: #d63384;
      }
    `,

    // Font & Line Height Formats
    lineheight_formats: '1 1.15 1.5 2 2.5 3',

    // Image Upload (Base64)
    images_upload_handler: (blobInfo, progress) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blobInfo.blob());
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    }),

    // UI Tweaks to match the clean look of the image
    branding: false,
    statusbar: true,
    resize: true,
    language: 'id',
    placeholder: 'Masukkan isi surat...',
  }

  // Configuration for Surat Lainnya (Keep consistent with default)
  const suratLainnyaInit = {
    ...defaultInit,
    height: 400,
  }

  // Minimal configuration
  const minimalInit = {
    height: 300,
    menubar: false,
    plugins: ['lists', 'link', 'autolink'],
    toolbar: 'bold italic underline | bullist numlist | link | removeformat',
    branding: false,
    promotion: false,
    onboarding: false,
    statusbar: false,
    language: 'id',
  }

  // Helper functions
  const stripHtml = (html) => {
    if (!html) return ''
    const tmp = document.createElement('DIV')
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ''
  }

  const isContentEmpty = (html) => {
    if (!html) return true
    const text = stripHtml(html).trim()
    return text.length === 0
  }

  const getCharacterCount = (html) => {
    return stripHtml(html).length
  }

  const getWordCount = (html) => {
    const text = stripHtml(html).trim()
    if (!text) return 0
    return text.split(/\s+/).length
  }

  return {
    Editor,
    apiKey,
    defaultInit,
    suratLainnyaInit,
    minimalInit,
    stripHtml,
    isContentEmpty,
    getCharacterCount,
    getWordCount,
  }
}
